import { fetchAllPaginatedList } from '@/utils/paginatedFetch';

/** 下拉／選項全量載入：分頁翻完，單頁不超過此上限（避免一次 200～500） */
export const SAFE_OPTION_PAGE_SIZE = 50;

/**
 * 安全取完分頁 API 全部列（每頁 SAFE_OPTION_PAGE_SIZE）。
 * @param {(params: { page: number, per_page: number }) => Promise<unknown>} fetchPage
 * @param {Record<string, unknown>} [extraParams]
 */
export const fetchAllOptionRows = (fetchPage, extraParams = {}) =>
    fetchAllPaginatedList(
        ({ page, per_page }) => fetchPage({ ...extraParams, page, per_page }),
        SAFE_OPTION_PAGE_SIZE
    );
